import React, { useEffect, useState, useRef } from 'react'
import { Button, Wrapper, TitleWrapper, SubMenu, SubMenuButton, Subtitle } from './index.styled'
import { VscAdd, VscChevronRight, VscChevronUp, VscRemove } from 'react-icons/vsc'
import { FormattedMessage } from 'react-intl';

const MenuExpansiveGroupComponent = ({
  icontype = "plus",  className = "", clickHandler = () => {}, clickSubmenuHandler = () => {},  info: { id, title, buttons, active, subtitle },
  activeSub = null
}) => {

  const [ activeSubButton, setActiveSubButton ] = useState(null);
  const [subHeight, setSubHeight ] = useState(0);

  const ref = useRef(null);


  const activeSubmenu = (item) => {
    setActiveSubButton(item?.id);
    clickSubmenuHandler(item)
  }

  const showSubmenu = () => {
    const allButtons = buttons.map((item, index) => {
      const _class = activeSubButton === item?.id ? 'active' : '';

      return (
        <SubMenuButton 
          key={item?.id} 
          className={_class} 
          onClick={() => activeSubmenu(item)} 
          delay={(index * .05) + .1}
        >
          <FormattedMessage id={item?.title} />
        </SubMenuButton>
      )
    })
    return allButtons;
  }

  useEffect(() => {
    setSubHeight(ref?.current?.clientHeight)
  }, [ active ])


  useEffect(() => {
    setActiveSubButton(activeSub)
  }, [activeSub])

  return (
    <Wrapper height={subHeight} className={className}>
      <Button onClick={() => clickHandler(id)}>
        <TitleWrapper>
          <FormattedMessage id={title} />
          {(subtitle !== '' && subtitle !== undefined) && <Subtitle><FormattedMessage id={subtitle} /></Subtitle>}
        </TitleWrapper>
        {buttons !== undefined && icontype === 'plus' && ((active) ? <VscRemove /> : <VscAdd />)}
        {buttons !== undefined && icontype === 'arrow' && ((active) ? <VscChevronUp /> : <VscChevronRight />)}
        
      </Button>
     
      {buttons &&
        (
          <SubMenu ref={ref}>
            {active && showSubmenu()}
          </SubMenu>
        )
      }
    </Wrapper>
  )
}


export default MenuExpansiveGroupComponent;
